export function billingRecipient(studentName, guardian) {
  if (!guardian || guardian.isPrimary === false) return { name: '보호자 미등록', valid: false };
  if (!['부', '모'].includes(guardian.relationship)) return { name: '보호자 관계 미지정', valid: false };
  const name = String(studentName || '').trim();
  return name ? { name: `${name} ${guardian.relationship}`, valid: true } : { name: '학생 이름 미등록', valid: false };
}
